import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import {
  OilFreeIcon,
  ParabenFreeIcon,
  SulfateFreeIcon,
} from 'on_web/assets/iconsList';
import {
  airPollutionHigh,
  airPollutionLow,
  airPollutionMedium,
  airPollutionVeryHigh,
  airPollutionVeryLow,
} from 'on_web/assets/imageList';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';
import { SKINCARE_COLOR } from 'colours';

export default function SkinCareStep4(props) {
  const context = React.useContext(UserProfileContext);

  const [selectedAllergies, setSelectedAllergies] = useState(
    context && context.userMetaData && context.userMetaData.pceSkinHairAllergies
      ? context.userMetaData.pceSkinHairAllergies
      : []
  );
  const [selectedAirPollution, setSelectedAirPollution] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.pceAirPollution != null
      ? context.userMetaData.pceAirPollution
      : undefined
  );

  const [metadata, setMetaData] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.pceSkinHairAllergiesOtherDesc
      ? context.userMetaData.pceSkinHairAllergiesOtherDesc
      : ''
  );

  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetadata = context ? context.userMetaData : null;

    if (props.onClickNext && userMetadata) {
      userMetadata.pceSkinHairAllergies = selectedAllergies;
      userMetadata.pceSkinHairAllergiesOtherDesc = metadata;
      userMetadata.pceAirPollution = selectedAirPollution;

      props.onClickNext(userMetadata);
    }
  };

  const questions = [
    {
      icon: <OilFreeIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep4.oilFree'),
      checked: selectedAllergies.includes('1'),
      value: '1',
    },
    {
      icon: <ParabenFreeIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep4.parabenFree'),
      checked: selectedAllergies.includes('2'),
      value: '2',
    },
    {
      icon: <SulfateFreeIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep4.sulfateFree'),
      checked: selectedAllergies.includes('3'),
      value: '3',
    },
    {
      icon: <SulfateFreeIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep4.other'),
      checked: selectedAllergies.includes('4'),
      value: '4',
    },
  ];

  const onAnswer = (val, checked) => {
    if (checked) {
      setSelectedAllergies([...selectedAllergies, val]);
    } else {
      setSelectedAllergies(selectedAllergies.filter(i => i !== val));
    }
  };

  const onAnswerMetadata = metadata => {
    setMetaData(metadata);
  };

  return (
    <React.Fragment>
      <Header />
      <PceStepProgressIndicator selectedSlideIx={2} />

      <Question
        sectionTitle={t(
          'pceOnboarding.skinCareSection.skinCareStep4.sectionTitle1'
        )}
        checkboxSelectionWithIcon={{
          items: questions,
          twoColumns: true,
          showMetaDataInputFor: '4',
        }}
        onAnswer={(val, checked) => onAnswer(val, checked)}
        onAnswerMetadata={metadata => onAnswerMetadata(metadata)}
        metadataValue={metadata}
        placeholder={'Text'}
      />

      <Question
        sectionTitle={t(
          'pceOnboarding.skinCareSection.skinCareStep4.sectionTitle2'
        )}
        animationImages={[
          {
            image: airPollutionVeryLow,
            height: 75,
          },
          {
            image: airPollutionLow,
            height: 75,
          },
          {
            image: airPollutionMedium,
            height: 75,
          },
          {
            image: airPollutionHigh,
            height: 75,
          },
          {
            image: airPollutionVeryHigh,
            height: 75,
          },
        ]}
        pointSelection={{
          color: SKINCARE_COLOR,
          selectedIx: selectedAirPollution,
          answers: [
            t('common.answers.answerVeryLow'),
            t('common.answers.answerLow'),
            t('common.answers.answerMedium'),
            t('common.answers.answerHigh'),
            t('common.answers.answerVeryHigh'),
          ],
          textOnBothSides: false,
        }}
        onAnswer={ix => setSelectedAirPollution(ix)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          selectedAllergies == null ||
          selectedAllergies.length === 0 ||
          selectedAirPollution === null
        }
      />
    </React.Fragment>
  );
}
